import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    IBulkCreateEntryJobRequest,
    IBulkCreateEntryJobResult,
    ICreateEntryJobRequest,
    IEntry,
    IEntryJob,
    IGetSignedUrlsRequest,
    IListEntriesRequest,
    IListEntryJobsRequest,
    ISignedUrlResponse,
} from '../../models/entry.interface';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class EntryService {
    static readonly endpoints = {
        entriesList: `${environment.apiUrl}/entries/list`,
        jobsList: `${environment.apiUrl}/entry-jobs/list`,
        jobs: `${environment.apiUrl}/entry-jobs`,
        upload: `${environment.apiUrl}/entry-jobs/upload`,
    };

    private http = inject(HttpClient);

    listEntries(request: IListEntriesRequest): Observable<IEntry[]> {
        return this.http.post<IEntry[]>(EntryService.endpoints.entriesList, request);
    }

    listEntryJobs(request: IListEntryJobsRequest): Observable<IEntryJob[]> {
        return this.http.post<IEntryJob[]>(EntryService.endpoints.jobsList, request);
    }

    createEntryJob(request: ICreateEntryJobRequest): Observable<IEntryJob> {
        return this.http.post<IEntryJob>(EntryService.endpoints.jobs, request);
    }

    bulkCreateEntryJobs(request: IBulkCreateEntryJobRequest): Observable<IBulkCreateEntryJobResult> {
        return this.http.post<IBulkCreateEntryJobResult>(`${EntryService.endpoints.jobs}/bulk`, request);
    }

    getUploadSignedUrls(request: IGetSignedUrlsRequest): Observable<ISignedUrlResponse> {
        return this.http.post<ISignedUrlResponse>(EntryService.endpoints.upload, request);
    }
}
